package org.catharsis.spendtel.core.navigation

actual fun defaultUnauthenticatedRoute(): String = AppRoutes.Landing.name

actual fun showsWebLandingPage(): Boolean = true
